<script setup lang="ts">
import { useDisplay } from 'vuetify';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import useLocale from '../composables/useLocale';

type Props = {
  title?: string;
  location: 'right' | 'left';
  icon: string;
};

defineProps<Props>();

const { smAndDown } = useDisplay();
const { t } = useLocale();

const isOpen = defineModel<boolean>({ required: true });
</script>

<template>
  <!-- Desktop: Navigation Drawer -->
  <v-navigation-drawer
    v-if="!smAndDown"
    data-testid="bp-side-drawer"
    v-model="isOpen"
    :location="location"
    temporary
    floating
    width="420"
    color="surface"
    class="pl-2 pr-2"
    :inert="!isOpen"
  >
    <v-toolbar color="transparent">
      <div class="d-flex ga-3 align-center pl-4">
        <FontAwesomeIcon :icon="icon" size="xl" />
        <v-toolbar-title>{{ title }}</v-toolbar-title>
      </div>
      <v-spacer />
      <v-btn
        icon
        data-testid="bp-side-drawer-close-btn"
        @click="isOpen = false"
        :aria-label="t('book_player.label_close_side_drawer', { sideDrawerContent: title })"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <div class="bg-surface-container-lowest rounded">
      <slot />
    </div>
  </v-navigation-drawer>
</template>

<style scoped lang="scss">
:deep(.v-list-item) {
  //Target the theme toggle button icon (icon-prepend)
  .icon-prepend {
    margin-left: 4px;
  }
}
</style>
